import React, { useState } from "react";
import { LangContext } from "../../contexts/LangContext";
import en from "../../i18n/en";
import pl from "../../i18n/pl";

export function SupportModal({ onClose, onSend }) {
  const { lang } = React.useContext(LangContext);
  const t = lang === "pl" ? pl : en;
  const [msg, setMsg] = useState("");

  const handleSend = () => {
    if (!msg.trim()) return;
    onSend(msg);
  };

  return (
    <div
      className="modal-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="modal-box" style={{ maxWidth: 480 }}>
        <div className="modal-header">
          <h2>{t.supportModal.supportTitle}</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <label className="form-label" style={{ marginBottom: 16 , fontSize: 13}} >{t.supportModal.supportHelp}</label>
            <textarea
              className="support-textarea"
              placeholder={t.supportModal.supportPlaceholder}
              value={msg}
              onChange={(e) => setMsg(e.target.value)}
            />
          </div>
          <div className="info-box" style={{ marginBottom: 16 }}>
            <span className="info-icon">⏰</span>
            <p>{t.supportModal.supportResponse}</p>
          </div>
          <div className="form-actions">
            <button className="btn-primary" style={{ flex: 1 }} onClick={handleSend}>
              {t.supportModal.sendMessage}
            </button>
            <button className="btn-cancel" onClick={onClose}>{t.cancel}</button>
          </div>
        </div>
      </div>
    </div>
  );
}